/* eslint-disable default-param-last */

/**
 * @description Reducer sobre as funções da edição de exame de confronto balístico
 * @author Diego Sabino Amorim de Araújo
 * @file edicaoExame/exameComparacaoReducer.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

const initialState = {
  exameComparacaoBalistica: {},
  activeStep: 0,
  processandoExameComparacaoBalistica: false,
  processandoLaudoViwer: false,
}

const exameComparacaoBalisticaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_EXAME_COMPARACAO_BALISTICA: {
      return {
        ...state,
        exameComparacaoBalistica: action.exameComparacaoBalistica,
      }
    }

    case types.SET_PROCESSANDO_EXAME_COMPARACAO_BALISTICA: {
      return {
        ...state,
        processandoExameComparacaoBalistica: action.isProcessando,
      }
    }

    case types.SET_ACTIVE_STEP_COMPARACAO_BALISTICA: {
      return {
        ...state,
        activeStep: action.activeStepComparacaoBalistica,
      }
    }

    default: {
      return {
        ...state,
      }
    }
  }
}

export default exameComparacaoBalisticaReducer
